import { handleApiGet, handleApiPut } from "./api";
import { BackendUrl } from "./newBackendApi";

export async function getKeywords(): Promise<string[]> {
  return handleApiGet(`${BackendUrl}/get-item/keywords`);
}

export function postKeywords(idToken: string, newKeywords: string[]) {
  return handleApiPut(`${BackendUrl}/admin/put-item/keywords`, idToken, {
    subCategories: newKeywords,
  });
}
